import { render } from "./Pagi.vue?vue&type=template&id=0fb06fb8"
import script from "./Pagi.vue?vue&type=script&lang=js"
export * from "./Pagi.vue?vue&type=script&lang=js"
script.render = render

export default script